export default "__VITE_ASSET__BE0JO9ms__"